export interface StoredAmenityPrefs {
  selected: string[];
  known: string[];
}

/**
 * Decide which amenities should be selected (shown) on the calendar.
 * - No stored prefs → select everything (and remember all as known).
 * - Stored prefs → keep the saved selection, but default ON any amenity not previously "known"
 *   (i.e. newly added since the user last looked), while honouring explicit deselections.
 * Legacy stored value (a bare string[] of selected ids) is treated as the saved selection with the
 * current full set marked known, so existing deselections are preserved and only future additions
 * default on.
 */
export function resolveAmenitySelection(
  currentIds: string[],
  stored: StoredAmenityPrefs | string[] | undefined,
): { selectedIds: string[]; known: string[] } {
  if (!stored) {
    return { selectedIds: [...currentIds], known: [...currentIds] };
  }
  const savedSelected = Array.isArray(stored) ? stored : stored.selected ?? [];
  const savedKnown = Array.isArray(stored) ? currentIds : stored.known ?? [];
  const keptSelected = savedSelected.filter((id) => currentIds.includes(id));
  const newlyAdded = currentIds.filter((id) => !savedKnown.includes(id));
  const selectedIds = Array.from(new Set([...keptSelected, ...newlyAdded]));
  return { selectedIds, known: [...currentIds] };
}
